import { Button,Box,Text, Grid, Heading, Modal, ModalBody, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay, Stack, VStack, Input, ModalFooter } from '@chakra-ui/react'
import React, { useState } from 'react'
import { RiDeleteBin7Fill } from 'react-icons/ri'

const CourseModal = ({isOpen,onClose,id,deleteButtonHandler,courseTitle,lectures=[1,2,3,4],addLecHandler}) => {
    const [title,setTitle]= useState()
    const [description,setDescription]=useState()
    const [video,setVideo]=useState()
    const [videoPreview,setVideoPreview]=useState()
    const changeVideoHandler=(e)=>{
        const file = e.target.files[0];
        const reader = new FileReader();

        reader.readAsDataURL(file);
        reader.onloadend=()=>{
            setVideoPreview(reader.result);
            setVideo(file);
        }
    }
    const handleClose=()=>{
        setDescription('')
        setTitle('')
        setVideo('')
        setVideoPreview('')
        onClose();
    }

  return (
    <Modal isOpen={isOpen} size='full' onClose={handleClose} scrollBehavior='outside'>
        <ModalOverlay />
        <ModalContent>
            <ModalHeader>
                {courseTitle}
            </ModalHeader>
            <ModalCloseButton onClick={onClose}/>
            <ModalBody p='16'>
                <Grid templateColumns={['1fr','3fr 1fr']}>
                    <Box px={['0','16']}>
                        <Box my='5'>
                            <Heading children={courseTitle}/>
                            <Heading children={`#${id}`} size='sm' opacity={0.4} />
                        </Box>
                        <Heading children='Lectures' size='lg'/>
                        {lectures.map((item,index)=>(
                            <VideoCard key={index} title='nodeJs'num={index+1} description='intro bois' lectureId='123abc' courseId={id} deleteButtonHandler={deleteButtonHandler} />
                        ))}
                    </Box>
                    <Box>
                        <form onSubmit={e=>addLecHandler(e,id,title,description,video)}>
                            <VStack spacing={'4'}>
                                <Heading children='Add Lecture' size={'md'}/>
                                <Input focusBorderColor='purple.300' placeholder='Title' value={title} onChange={(e)=>setTitle(e.target.value)} />
                                <Input focusBorderColor='purple.300' placeholder='Description' value={description} onChange={(e)=>setDescription(e.target.value)} />
                                <Input accept='video/mp4' required type={'file'} focusBorderColor='purple.300' 
                                    css={{
                                        "&::file-selector-button":{
                                        cursor:"pointer",marginLeft:"-5%",
                                        width:"110%",
                                        border:"none",
                                        height:"100%",
                                        color:'purple',
                                        backgroundColor:'white'
                                    }
                                    }}
                                    onChange={changeVideoHandler}
                                />
                                {videoPreview && (
                                    <video controlsList='nodownload' controls src={videoPreview}></video>
                                )}
                                <Button w='full' colorScheme={'purple'} type='submit'>Upload</Button>
                            </VStack>
                        </form>
                    </Box>
                </Grid>
            </ModalBody>
            <ModalFooter>
                <Button onClick={handleClose}>CLose</Button>
            </ModalFooter>
        </ModalContent>
    </Modal>
  )
}

export default CourseModal


function VideoCard({title,num,description,lectureId,courseId,deleteButtonHandler}){
    return <Stack direction={['column','row']} my='8' borderRadius={'lg'} boxShadow={'0 0 10px rgba(107,70,193,0.5)'} justifyContent={['flex-start','space-between']} p={['4','8']}>
        <Box>
            <Heading size={'sm'} children={`#${num} ${title}`} />
            <Text children={description} />
        </Box>
        <Button color={'purple.600'} onClick={()=>deleteButtonHandler(courseId,lectureId )}>
            <RiDeleteBin7Fill />
        </Button>
    </Stack>
}